/* --------------------------------------------
HappyNewYear!
-------------------------------------------- */
import * as Vivus from 'vivus';
import anime from 'animejs/lib/anime.es.js';

import {
  no_scroll,
  return_scroll
} from '../common/_common';

export function backAnimation2022Func() {
  let hny2022 = $('#hny2022').length;

  if (hny2022) {
    var c = document.getElementById("c");
    var ctx = c.getContext("2d");
    var cH;
    var cW;
    var bgColor = "#fff";
    var animations = [];
    var circles = [];

    var colorPicker = (function () {
      var colors = ["#ffc649", "#FF6138", "#2980B9", "#282741"];
      var index = 0;

      function next() {
        index = index++ < colors.length - 1 ? index : 0;
        return colors[index];
      }

      function current() {
        return colors[index]
      }
      return {
        next: next,
        current: current
      }
    })();

    function removeAnimation(animation) {
      var index = animations.indexOf(animation);
      if (index > -1) animations.splice(index, 1);
    }

    function calcPageFillRadius(x, y) {
      var l = Math.max(x - 0, cW - x);
      var h = Math.max(y - 0, cH - y);
      return Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2));
    }

    function addClickListeners() {
      document.addEventListener("touchstart", handleEvent);
      document.addEventListener("mousedown", handleEvent);
    };

    function handleEvent(e) {
      if (e.touches) {
        e.preventDefault();
        e = e.touches[0];
      }
      var currentColor = colorPicker.current();
      var nextColor = colorPicker.next();
      var targetR = calcPageFillRadius(e.pageX, e.pageY);
      var rippleSize = Math.min(200, (cW * .4));
      var minCoverDuration = 750;

      var pageFill = new Circle({
        x: e.pageX,
        y: e.pageY,
        r: 0,
        fill: nextColor
      });
      var fillAnimation = anime({
        targets: pageFill,
        r: targetR,
        duration: Math.max(targetR / 2, minCoverDuration),
        easing: "easeOutQuart",
        complete: function () {
          bgColor = pageFill.fill;
          removeAnimation(fillAnimation);
        }
      });

      var ripple = new Circle({
        x: e.pageX,
        y: e.pageY,
        r: 0,
        fill: currentColor,
        stroke: {
          width: 3,
          color: currentColor
        },
        opacity: 1
      });
      var rippleAnimation = anime({
        targets: ripple,
        r: rippleSize,
        opacity: 0,
        easing: "easeOutExpo",
        duration: 900,
        complete: removeAnimation
      });

      var particles = [];
      for (var i = 0; i < 32; i++) {
        var particle = new Circle({
          x: e.pageX,
          y: e.pageY,
          fill: currentColor,
          r: anime.random(24, 48)
        })
        particles.push(particle);
      }
      var particlesAnimation = anime({
        targets: particles,
        x: function (particle) {
          return particle.x + anime.random(rippleSize, -rippleSize);
        },
        y: function (particle) {
          return particle.y + anime.random(rippleSize * 1.15, -rippleSize * 1.15);
        },
        r: 0,
        easing: "easeOutExpo",
        duration: anime.random(1000, 1300),
        complete: removeAnimation
      });
      animations.push(fillAnimation, rippleAnimation, particlesAnimation);
    }

    function extend(a, b) {
      for (var key in b) {
        if (b.hasOwnProperty(key)) {
          a[key] = b[key];
        }
      }
      return a;
    }

    var Circle = function (opts) {
      extend(this, opts);
    }

    Circle.prototype.draw = function () {
      ctx.globalAlpha = this.opacity || 1;
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.r, 0, 2 * Math.PI, false);
      if (this.stroke) {
        ctx.strokeStyle = this.stroke.color;
        ctx.lineWidth = this.stroke.width;
        ctx.stroke();
      }
      if (this.fill) {
        ctx.fillStyle = this.fill;
        ctx.fill();
      }
      ctx.closePath();
      ctx.globalAlpha = 1;
    }

    var animate = anime({
      duration: Infinity,
      update: function () {
        ctx.fillStyle = bgColor;
        ctx.fillRect(0, 0, cW, cH);
        animations.forEach(function (anim) {
          anim.animatables.forEach(function (animatable) {
            animatable.target.draw();
          });
        });
      }
    });

    var resizeCanvas = function () {
      cW = window.innerWidth;
      cH = window.innerHeight;
      c.width = cW * devicePixelRatio;
      c.height = cH * devicePixelRatio;
      ctx.scale(devicePixelRatio, devicePixelRatio);
    };

    (function init() {
      resizeCanvas();
      if (window.CP) {
        // CodePen's loop detection was causin' problems
        // and I have no idea why, so...
        window.CP.PenTimer.MAX_TIME_IN_LOOP_WO_EXIT = 6000;
      }
      window.addEventListener("resize", resizeCanvas);
      addClickListeners();
      if (!!window.location.pathname.match(/fullcpgrid/)) {
        startFauxClicking();
      }
      handleInactiveUser();
    })();

    function handleInactiveUser() {
      var inactive = setTimeout(function () {
        fauxClick(cW / 2, cH / 2);
      }, 2000);

      function clearInactiveTimeout() {
        clearTimeout(inactive);
        document.removeEventListener("mousedown", clearInactiveTimeout);
        document.removeEventListener("touchstart", clearInactiveTimeout);
      }

      document.addEventListener("mousedown", clearInactiveTimeout);
      document.addEventListener("touchstart", clearInactiveTimeout);
    }

    function startFauxClicking() {
      setTimeout(function () {
        fauxClick(anime.random(cW * .2, cW * .8), anime.random(cH * .2, cH * .8));
        startFauxClicking();
      }, anime.random(200, 900));
    }

    function fauxClick(x, y) {
      var fauxClick = new Event("mousedown");
      fauxClick.pageX = x;
      fauxClick.pageY = y;
      document.dispatchEvent(fauxClick);
    }

  }
}

export function mainAnimation2022Func() {
  let hny2022 = $('#hny2022').length;

  if (hny2022) {
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms))

    function changePosition() {
      var flag = false;
      var $target = $('.spriteAnime');
      var LIMIT = 13;
      var i = 1;

      // 4秒経過ごとにマイナスする
      var tm = 2000;
      var id = setTimeout;

      var fn = function () {
        if (2 <= i && i < 13) {
          i--;
          $target.attr('class', 'is-position-' + i).addClass('spriteAnime');
          clearTimeout(id);
          id = setTimeout(fn,40);
        }
      }
      // var id = setInterval(fn, tm);
      
      //コインが大きくなった後のアニメーション
      var anime01 = function () {
        if (flag) {
        wait(1600)
          .then(() => {
            $target.addClass('spriteFinish');
            return wait(500)
          })
          .then(() => {
            $('.blackSvgAnime').addClass('isShow');
            $('#c').addClass('hidden');
            return wait(4000)
          })
          .then(() => {
            $('body').removeClass('fixed');
            $('body').css('overflow', 'auto');
            return_scroll();
            $('.txtContent').addClass('isShow');
            return wait(1000)
          })
          .then(() => {
            $('.inView').addClass('fadeIn');
            return wait(1200)
          })
        }
      }

      //コインクリック時のアニメーション
      var touchFlag = false;
      var click = true;
      $('.animeLayer').on('touchstart click', function(event) {
        clearTimeout(id);
        
        if (event.type === 'touchstart') {
          touchFlag = true;
        }

        if (touchFlag) {

          touchFlag = false;

        } else if(click) {

          i++;

          if (i >= LIMIT) {
            click=false;
            $target.attr('class', 'is-position-' + LIMIT).addClass('spriteAnime');
            clearTimeout(id);
            flag = true;
            anime01();
          } else{
            $target.attr('class', 'is-position-' + i).addClass('spriteAnime');
            id = setTimeout(fn, tm);
          }

        }
      });
    }
    
    $('body').addClass('fixed');
    $('body').css('overflow', 'hidden');
    $('html,body').animate({
      scrollTop: 0
    }, '0');
    no_scroll();
    changePosition();

    
    // scrollイベントを設定
    var pos = 0;
    function scrollEvent() {
      if($('.txtContent').scrollTop() < pos ){
        //上にスクロールしたとき
        $('.scroll').removeClass('hide');
      }else{
        //下にスクロールしたとき
        $('.scroll').addClass('hide');
      }
      pos = $('.txtContent').scrollTop();
    }

    let setTimer = false;
    $('.txtContent').on('scroll', function () {
      if (setTimer !== false) {
        clearTimeout(setTimer);
      }
      setTimer = setTimeout(() => {
        scrollEvent();
      }, 300);
    });

    //resize時のイベントを設定

    function scrollHight() {
      let txtContentHight = $('.txtContent').innerHeight();
      let txtContentInnerHight = $('.txtContent .container').innerHeight();

      if( txtContentInnerHight < txtContentHight ){
        $('.scroll').addClass('hide');
      }
    }

    scrollHight();
    $(window).on('resize', function () {
      if (setTimer !== false) {
        clearTimeout(setTimer);
      }
      setTimer = setTimeout(() => {
        scrollHight();
      }, 300);
    });

  }
}